import fetchDishes from "./fetchDishes";
const fetchMenu = (id, query) =>
  new Promise((resolve, reject) => {
    fetchDishes({ availableAt: id, ...query })
      .then(dishes => resolve(dishes))
      .catch(error => reject(error));
  });
export default fetchMenu;
